import { render, staticRenderFns } from "./otherLogin.vue?vue&type=template&id=a8289342"
import script from "./otherLogin.vue?vue&type=script&lang=js"
export * from "./otherLogin.vue?vue&type=script&lang=js"
import style0 from "./otherLogin.vue?vue&type=style&index=0&id=a8289342&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports